<template>
  <div class="min-h-screen flex justify-center text-gray-800">
    <div class="h-full flex basis-full mt-12">
      <ul role="list">
        <li
          v-for="item in layoutKeys"

          class="text-gray-800 text-lg cursor-pointer"
          :class="item === currentLayout && 'font-bold'"
          :key="item"

          @click="currentLayout = item"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div
      class="shrink-0 w-[1440px] my-4 rounded-lg   grid gap-4 grid-cols-12 grid-rows-12"
      :class="layouts[currentLayout].wrapper"
    >
      <div v-for="(number, index) in layouts[currentLayout].items" :key="number + index"
           class="rounded-lg bg-gray-200 border border-gray-300 p-3   grid gap-4 grid-cols-12 grid-rows-12"
           :class="layouts[currentLayout].items[index]"

           @click="tickLayout(index)"
      >
        <template v-if="subItemLayout[index] !== undefined">
          <div
            v-for="(block, subIndex) in layouts[layoutKeys[subItemLayout[index]]].items"
            :key="block + subIndex"

            class="rounded-lg bg-gray-300 border border-gray-400 text-xl font-bold flex justify-center items-center"
            :class="block"
          >
            {{ subIndex + 1 }}
          </div>
        </template>
      </div>
    </div>
    <div class="flex basis-full">
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      currentLayout: 'grid',
      layouts: {
        "landing-page": {
          id: 'landing-page',
          wrapper: "",
          items: ["col-span-12", "row-span-10 col-span-12", "col-span-12"],
        },
        "grid": {
          id: 'grid',
          wrapper: "",
          items: ["col-span-3 row-span-3", "col-span-3 row-span-3", "col-span-3 row-span-3", "col-span-3 row-span-3", "col-span-3 row-span-3", "col-span-3 row-span-3", "col-span-3 row-span-3"],
        },
        "catalog": {
          id: 'catalog',
          wrapper: "",
          items: ["col-span-12", "col-span-12", "row-span-10 col-span-3", "col-span-9", "col-span-9 row-span-8", "col-span-9", "col-span-12"],
        },
        "2column": {
          id: 'landing-page',
          wrapper: "",
          items: ["col-span-12", "col-span-3 row-span-11", "col-span-9 row-span-11"],
        },
        "3column": {
          id: 'landing-page',
          wrapper: "",
          items: ["col-span-12", "col-span-3 row-span-11", "col-span-6 row-span-11", "col-span-3 row-span-11"],
        },
      },
      subItemLayout: {

      },
    }
  },
  methods: {
    tickLayout(index) {
      const keys = this.layoutKeys
      if (!this.subItemLayout[index] && this.subItemLayout[index] !== 0) {
        this.subItemLayout[index] = 0
      } else {
        this.subItemLayout[index] = this.subItemLayout[index] + 1

        if (!keys[this.subItemLayout[index]]) {
          this.subItemLayout[index] = undefined
        }
      }

      this.subItemLayout = {...this.subItemLayout}
    },
  },
  computed: {
    layoutKeys() {
      return Object.keys(this.layouts)
    },
  },
  watch: {
    currentLayout() {
      this.subItemLayout = {}
    },
  },
}

</script>
